import { Box } from '@mui/material'
import { useLogin } from '@refinedev/core'
import { useParams, useSearchParams } from 'react-router'
import { useForm } from 'react-hook-form'
import { ShareLoginHeader, ShareLoginForm } from './components'

type TShareLoginFormData = {
  password: string
}

export const ShareLogin = () => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const { mutate: login, isLoading } = useLogin()

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<TShareLoginFormData>({
    mode: 'onChange',
    defaultValues: {
      password: '',
    },
  })

  const username = searchParams.get('username') || params.username
  const shareId = searchParams.get('share')

  const onSubmit = (data: TShareLoginFormData) => {
    const redirectTo = shareId ? `/share/${shareId}` : '/share'
    login({ username, password: data.password, redirectTo, isShare: true })
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
      <ShareLoginHeader />
      <ShareLoginForm
        control={control}
        errors={errors}
        isValid={isValid}
        isLoading={isLoading}
        onSubmit={handleSubmit(onSubmit)}
      />
    </Box>
  )
}
